import en from './en'
import cn from './cn'
export default {
  en,
  cn,
  setLang (lang) {
    window.localStorage.setItem('user_lang', lang)
  },
  getLang (defaultLang) {
    let localLang = window.localStorage.getItem('user_lang')

    if (localLang === null) {
      return defaultLang
    } else {
      return localLang
    }
  }
}
